import { ProfileDataType } from "../types/ProfileDataType";
import { fetchCustomersByEmail } from "./customerAPI";
import { mapProfileData } from "../utils/formatProfileData";
import { AuthApiService } from "../service/authService";

export const fetchProfileData = async (): Promise<ProfileDataType | null> => {
  try {
    // Fetch the ID token
    const idToken = await AuthApiService.fetchIdTokenFromCognitoSession();

    if (!idToken) {
      console.error("ID Token not found. User might not be logged in.");
      return null;
    }

    // Extract user email from ID Token
    const { userEmail } = await AuthApiService.getUserEmail(idToken);

    if (!userEmail) {
      console.error("User email not found in token.");
      return null;
    }

    // Fetch customer profile data using the email
    const data = await fetchCustomersByEmail({ emailId: userEmail });

    const profileData = mapProfileData(data);

    return profileData;
  } catch (error) {
    console.error("Error fetching profile data:", error);
    return null;
  }
};
